import Vue from 'vue'

export default {
    access() {
        return Vue.axios.get(`/role/access`, {})
    },
    list(params) {
        return Vue.axios.get(`/role`, {params})
    },
    create(params) {
        return Vue.axios.post(`/role/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/role/update`, params)
    },
    remove(id) {
        return Vue.axios.get(`/role/remove/${id}`)
    },
}
